export const getCreatorApiUrl = (path) =>
  import.meta.env.VITE_CREATOR_API_URL + path;
const getConsumerApiUrl = (path) =>
  import.meta.env.VITE_CONSUMER_API_URL + path;
